import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { database } from '../../helper/firebase.helper';

const COLLECTION_PATH = 'feedbacks';

export const getFeedback = async (feedbackId) => {
  if (!feedbackId) return null;
  const feedbackRef = doc(database, `${COLLECTION_PATH}/${feedbackId}`);
  try {
    const feedbackSnap = await getDoc(feedbackRef);
    if (feedbackSnap.exists()) {
      return { id: feedbackSnap.id, ...feedbackSnap.data() };
    } else {
      console.log('No such feedback document!');
      return null;
    }
  } catch (error) {
    console.log('Error fetching feedback document: ', error);
    return null;
  }
};

export const saveFeedback = async (feedbackId, { stars, comment }) => {
  if (!feedbackId) throw new Error('feedbackId is required');
  const feedbackRef = doc(database, `${COLLECTION_PATH}/${feedbackId}`);
  const now = Date.now();
  const newStars = typeof stars === 'number' ? stars : 0;
  const newComment = typeof comment === 'string' ? comment.trim() : '';
  try {
    await updateDoc(feedbackRef, {
      stars: newStars,
      comment: newComment || '',
      completed: !!newStars,
      updateAt: now
    });
  } catch (error) {
    console.log('Error saving feedback document: ', error);
    throw error;
  }
};
